import { reducer as userListReducer } from './list/index';

export default {
  userList: userListReducer
};
